/**
 * Pure support ticket enums — no SCSS/JSX imports so any consumer can
 * import safely without circular dependency or default-export interop issues.
 */
export const SUPPORT_TICKET_STATUS = Object.freeze({
    OPEN: 'open',
    PENDING: 'pending',
    AWAITING_CUSTOMER: 'awaiting_customer',
    RESOLVED: 'resolved',
    CLOSED: 'closed',
});

export const SupportTicketConstants = Object.freeze({
    STATUS: SUPPORT_TICKET_STATUS,
    LIST_STATUS_TABS: [
        { key: 'all', label: 'All' },
        { key: SUPPORT_TICKET_STATUS.OPEN, label: 'Open' },
        { key: SUPPORT_TICKET_STATUS.PENDING, label: 'Pending' },
        { key: SUPPORT_TICKET_STATUS.AWAITING_CUSTOMER, label: 'Awaiting customer' },
        { key: SUPPORT_TICKET_STATUS.RESOLVED, label: 'Resolved' },
        { key: SUPPORT_TICKET_STATUS.CLOSED, label: 'Closed' },
    ],
    AUTHOR_ROLE: Object.freeze({
        ADMIN: 'admin',
        STAFF: 'staff',
        /** @deprecated Legacy rows only; new staff replies use STAFF. */
        CLOCKOUT: 'clockout',
    }),
    SUBJECT_MAX_LENGTH: 256,
    BODY_MAX_LENGTH: 10000,
    LIST_PER_PAGE: 10,
    DETAIL_MESSAGES_PER_PAGE: 10,
    LIST_STATUS_DEFAULT: 'all',
    LIST_STATUS_PARAM: 'status',
});

export const CATEGORY_OPTIONS = [
    { value: 'error', label: 'Error' },
    { value: 'question', label: 'Question' },
    { value: 'feature_request', label: 'Feature request' },
];

export const PRIORITY_OPTIONS = [
    { value: 'high', label: 'High' },
    { value: 'normal', label: 'Normal' },
    { value: 'low', label: 'Low' },
];

export default SupportTicketConstants;
